import { supabase } from "../supabase/client";

export const DRIVER_HOLIDAY_BLOCK_MESSAGE = "해당 기사님은 해당 날짜에 휴일을 신청해두셨습니다.";

const NON_BLOCKING_HOLIDAY_STATUSES = new Set([
  "비승인",
  "반려",
  "거절",
  "취소",
  "cancelled",
  "canceled",
  "rejected",
  "denied",
]);

function normalizeDriverName(value = "") {
  return String(value || "").trim().replace(/\s+/g, " ");
}

function normalizePhone(value = "") {
  return String(value || "").replace(/\D/g, "");
}

function normalizeDate(value = "") {
  return String(value || "").slice(0, 10);
}

export function isDriverHolidayBlockingStatus(status = "") {
  const normalized = String(status || "").trim();
  if (!normalized) return true;
  return !NON_BLOCKING_HOLIDAY_STATUSES.has(normalized) &&
    !NON_BLOCKING_HOLIDAY_STATUSES.has(normalized.toLowerCase());
}

function isDateInRange(date, from, to) {
  return !!date && !!from && !!to && from <= date && date <= to;
}

function isSameHolidayDriver(holiday = {}, candidate = {}) {
  const holidayPhone = normalizePhone(holiday.phone);
  const candidatePhone = normalizePhone(candidate.phone);
  if (holidayPhone && candidatePhone && holidayPhone === candidatePhone) return true;

  const holidayDriver = normalizeDriverName(holiday.driver);
  return !!holidayDriver && holidayDriver === candidate.driverName;
}

export async function findDriverHolidayConflict(rows = [], company) {
  const candidates = rows
    .map((row) => ({
      row,
      date: normalizeDate(row?.date),
      driverName: normalizeDriverName(row?.human_name || row?.driver_name || row?.driver),
      phone: row?.phone || "",
    }))
    .filter((candidate) => candidate.date && candidate.driverName);

  if (!company || candidates.length === 0) return null;

  const sortedDates = candidates.map((candidate) => candidate.date).sort();
  const minDate = sortedDates[0];
  const maxDate = sortedDates[sortedDates.length - 1];

  const { data, error } = await supabase
    .from("holidays_driver")
    .select("id, driver, phone, from, to, status")
    .eq("company", company)
    .lte("from", maxDate)
    .gte("to", minDate);

  if (error) throw error;

  const blockingHolidays = (data || []).filter((holiday) =>
    isDriverHolidayBlockingStatus(holiday.status)
  );

  for (const candidate of candidates) {
    const holiday = blockingHolidays.find((item) =>
      isSameHolidayDriver(item, candidate) &&
      isDateInRange(candidate.date, normalizeDate(item.from), normalizeDate(item.to))
    );

    if (holiday) {
      return {
        row: candidate.row,
        holiday,
      };
    }
  }

  return null;
}

export function clearDriverAssignment(row = {}) {
  return {
    ...row,
    human_name: "",
    phone: "",
    driver_email: "",
  };
}
